import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles(() => ({
  formControl: {
    width: "100%",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
}));
